export default function debug(data) {
  if (('' + window.location.host).indexOf('.test') !== -1) console.log(data)
}
